import api from './api';
import { META_TAGS } from '../config/Config';

// Cache for tags to prevent duplicate API calls
let tagsCache = null;
let tagsCacheTimestamp = null;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export const metaTagService = {
  // Get all meta tags (filtered by user permissions)
  list: async (params = {}) => {
    const response = await api.get(META_TAGS, { params });
    return response.data;
  },

  // Get meta tag by ID
  get: async (id) => {
    const response = await api.get(`${META_TAGS}${id}/`);
    return response.data;
  },

  // Create new meta tag (admin only)
  create: async (data) => {
    const response = await api.post(META_TAGS, data);
    return response.data;
  },

  // Update existing meta tag (admin only)
  update: async (id, data) => {
    const response = await api.patch(`${META_TAGS}${id}/`, data);
    return response.data;
  },

  // Delete meta tag (admin only)
  remove: async (id) => {
    await api.delete(`${META_TAGS}${id}/`);
  },

  async getActiveTags() {
    // Check if we have valid cached data
    if (tagsCache && tagsCacheTimestamp && (Date.now() - tagsCacheTimestamp) < CACHE_DURATION) {
      console.log('metaTagService: Returning cached tags');
      return tagsCache;
    }

    try {
      console.log('metaTagService: Fetching fresh tags from API');
      const response = await api.get(`${META_TAGS}?is_active=true`);
      
      // Cache the response
      tagsCache = response.data;
      tagsCacheTimestamp = Date.now();
      
      return response.data;
    } catch (error) {
      console.error('metaTagService: Failed to fetch tags:', error);
      throw error;
    }
  },

  async searchTags(searchTerm, limit = 10) {
    const params = {
      search: searchTerm,
      page_size: limit
    };
    
    const { data } = await api.get(META_TAGS, { params });
    return data;
  },

  // Method to clear cache when needed (e.g., after tag creation/update)
  clearCache() {
    tagsCache = null;
    tagsCacheTimestamp = null;
    console.log('metaTagService: Cache cleared');
  },

  // Method to force refresh tags
  async refreshTags() {
    this.clearCache();
    return await this.getActiveTags();
  },

  // Get all tags with active filter (admin only)
  getTagsWithFilter: async (isActive = null) => {
    const params = {};
    if (isActive !== null) {
      params.is_active = isActive;
    }
          const response = await api.get(META_TAGS, { params });
    return response.data;
  }
};
